const nf = (d) => new Intl.NumberFormat("id-ID", { minimumFractionDigits: d, maximumFractionDigits: d });

export function rp(v) {
  const a = Math.abs(v);
  if (a >= 1e12) return `Rp ${nf(2).format(v / 1e12)} T`;
  if (a >= 1e9) return `Rp ${nf(2).format(v / 1e9)} M`;
  if (a >= 1e6) return `Rp ${nf(1).format(v / 1e6)} Jt`;
  return `Rp ${nf(0).format(v)}`;
}

export function fmt(v, f) {
  if (v === null || v === undefined || Number.isNaN(v)) return "–";
  switch (f) {
    case "rp": return rp(v);
    case "pct": return `${nf(2).format(v * 100)}%`;
    case "min": return `${nf(2).format(v)} mnt`;
    case "score": return nf(2).format(v);
    case "num": return Number.isInteger(v) ? nf(0).format(v) : nf(2).format(v);
    default: return String(v);
  }
}

export function fmtAxis(v, f) {
  if (v == null) return "";
  if (f === "rp") {
    const a = Math.abs(v);
    if (a >= 1e9) return `${nf(1).format(v / 1e9)} M`;
    if (a >= 1e6) return `${nf(0).format(v / 1e6)} Jt`;
    return nf(0).format(v);
  }
  if (f === "pct") return `${nf(0).format(v * 100)}%`;
  if (f === "num") return nf(0).format(v);
  return nf(1).format(v);
}

export const axisFmt = (t) => (v) => (v == null ? "" : t.scale ? nf(1).format(v / t.scale) : fmtAxis(v, t.fmt));
export const tipFmt = (t) => (v) => (t.scale && v != null ? `Rp ${nf(2).format(v / t.scale)} Jt` : fmt(v, t.fmt));

export const STATUS = {
  green: { label: "Tercapai", cls: "bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-950/40 dark:text-emerald-400 dark:border-emerald-800", bar: "bg-emerald-500" },
  yellow: { label: "Waspada", cls: "bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-950/40 dark:text-amber-400 dark:border-amber-800", bar: "bg-amber-500" },
  red: { label: "Belum Capai", cls: "bg-rose-50 text-rose-700 border-rose-200 dark:bg-rose-950/40 dark:text-rose-400 dark:border-rose-800", bar: "bg-rose-500" },
};

export const ROLE_LABEL = { admin: "Admin", manajemen: "Manajemen", operasional: "Tim Operasional", viewer: "Viewer" };

export const delta = (v, prev) => (v == null || prev == null || prev === 0 ? null : (v - prev) / Math.abs(prev));

export const fmtDate = (iso) =>
  iso ? new Date(iso).toLocaleString("id-ID", { dateStyle: "medium", timeStyle: "short" }) : "–";

export const BULAN = ["Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "September", "Oktober", "November", "Desember"];
